import { Component } from 'react';
import { API_ENDPOINT } from '../../constants';
import ListBuilder from '../../components/listBuilder';
import Page from '../../containers/page';
import { updateParamsHelper, getParamsFromURL } from '../../helpers/custom.helper';
import { Container, Row, Col } from 'reactstrap';

class JournalWebhookLogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            params: {
                entries: 10,
                page: 0,
                sortField: '_id',
                sortType: -1,
                filter: '',
            },
            loading: true,
            initialList: [],
            error: null,
        };
    }

    get = async () => {
        this.setState({ loading: true, initialList: [] });

        try {
            const response = await fetch(`${API_ENDPOINT}/journal/webhook-logs/get`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({
                    groupAlias: localStorage.getItem('groupAlias'),
                    total: this.state.total,
                    entries: this.state.params?.entries,
                    page: this.state.params?.page,
                    sortField: this.state.params?.sortField,
                    sortType: this.state.params?.sortType,
                    filter: this.state.params?.filter,
                }),
            });

            const data = await response.json();

            if (data.items) {
                this.setState({ loading: false, initialList: data.items, total: data.total });
            } else {
                this.setState({ loading: false, error: data.error || null });
            }
        } catch (err) {
            this.setState({ loading: false, error: err?.message || 'Error fetching webhook logs' });
        }
    };

    componentDidMount() {
        const urlParams = getParamsFromURL();

        const newParams = {
            ...this.state.params,
            entries: urlParams.entries,
            filter: urlParams.filter,
        };

        this.setState({ params: newParams }, () => {
            if (this.props.initialList) {
                this.setState({ loading: false, initialList: this.props.initialList });
            } else {
                this.get();
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps._groupId !== this.props._groupId ||
            prevProps.view !== this.props.view
        ) {
            this.get();
        }
    }

    updateSort = (field, type) => {
        updateParamsHelper(this, { sortField: field, sortType: type });
    };

    updateParams = (name, value, restart = false) => {
        updateParamsHelper(this, { [name]: value }, restart);
    };

    updateMultipleParams = (fields, restart = false) => {
        updateParamsHelper(this, fields, restart);
    };

    formatTs = (id) => {
        if (!id) return '-';
        try {
            const ts = parseInt(String(id).substring(0, 8), 16) * 1000;
            return new Date(ts).toLocaleString('sv-SE');
        } catch {
            return '-';
        }
    };

    render() {
        const { params, initialList, loading, total } = this.state;

        return (
            <div className={this.props.autoHideSidebar ? 'dashboard dashboard-auto-hide' : 'dashboard'}>
                <Container fluid>
                    <Row>
                        <Col lg='12'>
                            <div className='panel aeb-panel'>
                                <div className='panel-header'>
                                    <h5 className='component-header'>
                                        {'Journal Webhook Logs'.translate(this.props.lang)}
                                    </h5>
                                </div>

                                <ListBuilder
                                    lang={this.props.lang}
                                    loading={loading}
                                    total={total}
                                    hideEntries={false}
                                    showNumeration={false}
                                    fields={[
                                        { type: 'text', label: 'Time'.translate(this.props.lang), name: 'tsFormatted' },
                                        { type: 'text', label: 'Model'.translate(this.props.lang), name: 'model' },
                                        { type: 'text', label: 'Action'.translate(this.props.lang), name: 'action' },
                                        { type: 'text', label: 'Authorized'.translate(this.props.lang), name: 'authorizedBadge' },
                                        { type: 'text', label: 'IP'.translate(this.props.lang), name: 'ip' },
                                        { type: 'text', label: 'Deduplication ID'.translate(this.props.lang), name: 'deduplicationId' },
                                        { type: 'text', label: 'Body'.translate(this.props.lang), name: 'bodyStr' },
                                    ]}
                                    items={initialList.map((item) => ({
                                        ...item,
                                        tsFormatted: this.formatTs(item._id),
                                        authorizedBadge: (
                                            <span style={{ color: item.authorized ? 'green' : 'red', fontWeight: 600 }}>
                                                {item.authorized ? 'Yes' : 'No'}
                                            </span>
                                        ),
                                        bodyStr: (
                                            <pre style={{ fontSize: 11, margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all', maxHeight: 120, overflow: 'auto' }}>
                                                {JSON.stringify(item.body, null, 2)}
                                            </pre>
                                        ),
                                    }))}
                                    rawItems={this.state.initialList}
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Page(JournalWebhookLogs);
